import createIcon from '../../createIcon';

/**
 * @component @name IncompleteCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTJDMjIgMTcuNTIgMTcuNTIgMjIgMTIgMjJDNi40OCAyMiAyIDE3LjUyIDIgMTJDMiA5LjI0IDMuMTIgNi43NCA0LjkzIDQuOTNMMTIgMTJWMkMxNy41MiAyIDIyIDYuNDggMjIgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const IncompleteCircle = createIcon('IncompleteCircle', [
  [
    'path',
    {
      d: 'M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 9.24 3.12 6.74 4.93 4.93L12 12V2C17.52 2 22 6.48 22 12Z',
      key: 'rlfm7j',
    },
  ],
]);

export default IncompleteCircle;
